import { UseFormProps, useForm } from "react-hook-form";

import {
  ObjectType,
  ObjectTypeFragment,
  OperationModeOptionFragment,
  OperationModes,
  SourcePropertyFragment,
} from "@/apollo/types";

import {
  DestinationPropertyOption,
  FixedDestinationPropertyOption,
  ModelMappingState,
} from "../../state/StepStateContext";

export type PropertyMappingFormValue = {
  destinationProperty?: DestinationPropertyOption | null;
  isRequired?: boolean;
  sourceProperty?: SourcePropertyFragment | null;
};

export type SourceModel = {
  id: string;
  emoji: string;
  name: string;
  folderPath: {
    id: string;
    name: string;
  }[];
};

export type FormValues = {
  objectTypeOption: ObjectType | null;
  objectTypeSettings: Record<string, any> | null;
  operation: OperationModeOptionFragment;
  model: SourceModel | null;
  primaryMapping: {
    sourceProperty?: SourcePropertyFragment;
    destinationProperty?: FixedDestinationPropertyOption;
  } | null;
  mappings: PropertyMappingFormValue[];
};

export function useMappingForm(
  initialState: ModelMappingState | null,
  objectTypes: ObjectTypeFragment[],
  options: UseFormProps<FormValues> = {},
) {
  return useForm<FormValues>({
    mode: "onSubmit",
    reValidateMode: "onChange",
    ...options,
    defaultValues: {
      model: initialState?.model || null,
      objectTypeOption: initialState?.objectType
        ? initialState?.objectType
        : objectTypes.length === 1
          ? objectTypes[0]
          : null,
      objectTypeSettings: initialState?.objectTypeSettings || null,
      operation: initialState?.operation || {
        id: "",
        operationMode: OperationModes.Insert,
      },
      mappings: initialState?.mappings ?? [
        {
          destinationProperty: null,
          isRequired: false,
          sourceProperty: null,
        },
      ],
      primaryMapping: initialState?.primaryMapping ?? null,
    },
  });
}
